module.exports = __webpack_public_path__ + "static/media/condorcet_1.a8b1bed9.png";